export enum AgreementTypeEnum {
  termsOfService = 'Terms of Service',
  privacyPolicy = 'Privacy Policy',
}
